export default __webpack_public_path__ + "static/media/14-INT-(4-3).8425574c.jpg";